export default string => string.replace(/\W+(.)/g, (match, character) => character.toUpperCase());
